// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Renderer__Context from "./Renderer__Context.bs.js";
import * as Renderer__Accessor from "./Renderer__Accessor.bs.js";
import * as Renderer__SettingsJSON from "./Renderer__SettingsJSON.bs.js";

var bindingKey = "__pbBind";

var nodeKey = "__pbNode";

function getDynamicPathFromSettings(settings) {
  return Core__Option.flatMap(Core__JSON.Decode.object(Renderer__SettingsJSON.ValueJSON.toJson(settings)), (function (dict) {
                var binding = dict[bindingKey];
                return Core__Option.flatMap(binding, Renderer__Accessor.Path.deserialize);
              }));
}

function getNodeFromSettings(settings) {
  return Core__Option.getOr(Core__Option.flatMap(Core__JSON.Decode.object(Renderer__SettingsJSON.ValueJSON.toJson(settings)), (function (dict) {
                    return Core__Option.flatMap(dict[nodeKey], Core__JSON.Decode.bool);
                  })), false);
}

var decodeContext = Core__JSON.Decode.string;

function decode(dataType) {
  if (dataType.TAG === "String") {
    return dataType._0;
  }
  
}

function $$eval(x, context) {
  if (x.TAG === "Static") {
    return Caml_option.some(x._0);
  } else {
    return Core__Option.flatMap(Renderer__Context.extractValue(context, x._0), decodeContext);
  }
}

function evalOpt(x, context) {
  return Core__Option.flatMap(x, (function (__x) {
                return $$eval(__x, context);
              }));
}

function make(x) {
  if (x.TAG === "Static") {
    return Core__Option.map(decode(x._0), (function (v) {
                  return {
                          TAG: "Static",
                          _0: v
                        };
                }));
  } else {
    return {
            TAG: "Dynamic",
            _0: x._0
          };
  }
}

function get(settings, key) {
  return Core__Option.flatMap(settings[key], make);
}

var $$String = {
  $$eval: $$eval,
  evalOpt: evalOpt,
  make: make,
  get: get
};

var decodeContext$1 = Core__JSON.Decode.$$float;

function decode$1(dataType) {
  if (dataType.TAG === "Float") {
    return dataType._0;
  }
  
}

function $$eval$1(x, context) {
  if (x.TAG === "Static") {
    return Caml_option.some(x._0);
  } else {
    return Core__Option.flatMap(Renderer__Context.extractValue(context, x._0), decodeContext$1);
  }
}

function evalOpt$1(x, context) {
  return Core__Option.flatMap(x, (function (__x) {
                return $$eval$1(__x, context);
              }));
}

function make$1(x) {
  if (x.TAG === "Static") {
    return Core__Option.map(decode$1(x._0), (function (v) {
                  return {
                          TAG: "Static",
                          _0: v
                        };
                }));
  } else {
    return {
            TAG: "Dynamic",
            _0: x._0
          };
  }
}

function get$1(settings, key) {
  return Core__Option.flatMap(settings[key], make$1);
}

var Float = {
  $$eval: $$eval$1,
  evalOpt: evalOpt$1,
  make: make$1,
  get: get$1
};

var decodeContext$2 = Core__JSON.Decode.bool;

function decode$2(dataType) {
  if (dataType.TAG === "Bool") {
    return dataType._0;
  }
  
}

function $$eval$2(x, context) {
  if (x.TAG === "Static") {
    return Caml_option.some(x._0);
  } else {
    return Core__Option.flatMap(Renderer__Context.extractValue(context, x._0), decodeContext$2);
  }
}

function evalOpt$2(x, context) {
  return Core__Option.flatMap(x, (function (__x) {
                return $$eval$2(__x, context);
              }));
}

function make$2(x) {
  if (x.TAG === "Static") {
    return Core__Option.map(decode$2(x._0), (function (v) {
                  return {
                          TAG: "Static",
                          _0: v
                        };
                }));
  } else {
    return {
            TAG: "Dynamic",
            _0: x._0
          };
  }
}

function get$2(settings, key) {
  return Core__Option.flatMap(settings[key], make$2);
}

var Bool = {
  $$eval: $$eval$2,
  evalOpt: evalOpt$2,
  make: make$2,
  get: get$2
};

var decodeContext$3 = Core__JSON.Decode.object;

function decode$3(dataType) {
  if (dataType.TAG === "Object") {
    return Caml_option.some(dataType._0);
  }
  
}

function $$eval$3(x, context) {
  if (x.TAG === "Static") {
    return Caml_option.some(x._0);
  } else {
    return Core__Option.flatMap(Renderer__Context.extractValue(context, x._0), decodeContext$3);
  }
}

function evalOpt$3(x, context) {
  return Core__Option.flatMap(x, (function (__x) {
                return $$eval$3(__x, context);
              }));
}

function make$3(x) {
  if (x.TAG === "Static") {
    return Core__Option.map(decode$3(x._0), (function (v) {
                  return {
                          TAG: "Static",
                          _0: v
                        };
                }));
  } else {
    return {
            TAG: "Dynamic",
            _0: x._0
          };
  }
}

function get$3(settings, key) {
  return Core__Option.flatMap(settings[key], make$3);
}

var $$Object = {
  $$eval: $$eval$3,
  evalOpt: evalOpt$3,
  make: make$3,
  get: get$3
};

function decodeContext$4(x) {
  return Core__Option.map(Core__JSON.Decode.array(x), (function (__x) {
                return Core__Array.filterMap(__x, Core__JSON.Decode.object);
              }));
}

function decode$4(dataType) {
  if (dataType.TAG === "List") {
    return dataType._0;
  }
  
}

function $$eval$4(x, context) {
  if (x.TAG === "Static") {
    return Caml_option.some(x._0);
  } else {
    return Core__Option.flatMap(Renderer__Context.extractValue(context, x._0), decodeContext$4);
  }
}

function evalOpt$4(x, context) {
  return Core__Option.flatMap(x, (function (__x) {
                return $$eval$4(__x, context);
              }));
}

function make$4(x) {
  if (x.TAG === "Static") {
    return Core__Option.map(decode$4(x._0), (function (v) {
                  return {
                          TAG: "Static",
                          _0: v
                        };
                }));
  } else {
    return {
            TAG: "Dynamic",
            _0: x._0
          };
  }
}

function get$4(settings, key) {
  return Core__Option.flatMap(settings[key], make$4);
}

var List = {
  $$eval: $$eval$4,
  evalOpt: evalOpt$4,
  make: make$4,
  get: get$4
};

function decodeContext$5(x) {
  return Core__Option.flatMap(Core__JSON.Decode.object(x), (function (dict) {
                var isNode = Core__Option.getOr(Core__Option.flatMap(dict[nodeKey], Core__JSON.Decode.bool), false);
                if (!isNode) {
                  return ;
                }
                var node = Core__Option.map(Core__Option.flatMap(dict["node"], Core__JSON.Decode.object), (function (prim) {
                        return prim;
                      }));
                return Core__Option.map(node, (function (v) {
                              return {
                                      __pbNode: true,
                                      node: v
                                    };
                            }));
              }));
}

function decode$5(dataType) {
  if (dataType.TAG === "Node") {
    return dataType._0;
  }
  
}

function $$eval$5(x, context) {
  if (x.TAG === "Static") {
    return Caml_option.some(x._0);
  } else {
    return Core__Option.flatMap(Renderer__Context.extractValue(context, x._0), decodeContext$5);
  }
}

function evalOpt$5(x, context) {
  return Core__Option.flatMap(x, (function (__x) {
                return $$eval$5(__x, context);
              }));
}

function make$5(x) {
  if (x.TAG === "Static") {
    return Core__Option.map(decode$5(x._0), (function (v) {
                  return {
                          TAG: "Static",
                          _0: v
                        };
                }));
  } else {
    return {
            TAG: "Dynamic",
            _0: x._0
          };
  }
}

function get$5(settings, key) {
  return Core__Option.flatMap(settings[key], make$5);
}

var $$Node = {
  $$eval: $$eval$5,
  evalOpt: evalOpt$5,
  make: make$5,
  get: get$5
};

function deserialize(valueRaw) {
  var v = Renderer__SettingsJSON.ValueJSON.classify(valueRaw);
  if (typeof v !== "object") {
    return ;
  }
  switch (v.TAG) {
    case "String" :
        return {
                TAG: "Static",
                _0: {
                  TAG: "String",
                  _0: v._0
                }
              };
    case "Float" :
        return {
                TAG: "Static",
                _0: {
                  TAG: "Float",
                  _0: v._0
                }
              };
    case "Bool" :
        return {
                TAG: "Static",
                _0: {
                  TAG: "Bool",
                  _0: v._0
                }
              };
    case "List" :
        return {
                TAG: "Static",
                _0: {
                  TAG: "List",
                  _0: Core__Array.filterMap(v._0, Core__JSON.Decode.object)
                }
              };
    case "Object" :
        var v$1 = v._0;
        var path = getDynamicPathFromSettings(valueRaw);
        if (path !== undefined) {
          return {
                  TAG: "Dynamic",
                  _0: Caml_option.valFromOption(path)
                };
        }
        var isNode = getNodeFromSettings(valueRaw);
        if (!isNode) {
          return {
                  TAG: "Static",
                  _0: {
                    TAG: "Object",
                    _0: v$1
                  }
                };
        }
        var node = Core__Option.map(Core__Option.flatMap(v$1["node"], Core__JSON.Decode.object), (function (prim) {
                return prim;
              }));
        return Core__Option.map(node, (function (v) {
                      return {
                              TAG: "Static",
                              _0: {
                                TAG: "Node",
                                _0: {
                                  __pbNode: true,
                                  node: v
                                }
                              }
                            };
                    }));
    
  }
}

function deserialize$1(settingsRaw) {
  return Object.fromEntries(Core__Option.getOr(Core__Option.map(Renderer__SettingsJSON.entries(settingsRaw), (function (__x) {
                        return Core__Array.filterMap(__x, (function (param) {
                                      var key = param[0];
                                      return Core__Option.map(deserialize(param[1]), (function (value) {
                                                    return [
                                                            key,
                                                            value
                                                          ];
                                                  }));
                                    }));
                      })), []));
}

function getString(v, key, context) {
  return Core__Option.flatMap(get(v, key), (function (__x) {
                return $$eval(__x, context);
              }));
}

function getFloat(v, key, context) {
  return Core__Option.flatMap(get$1(v, key), (function (__x) {
                return $$eval$1(__x, context);
              }));
}

function getBool(v, key, context) {
  return Core__Option.flatMap(get$2(v, key), (function (__x) {
                return $$eval$2(__x, context);
              }));
}

function getObject(v, key, context) {
  return Core__Option.flatMap(get$3(v, key), (function (__x) {
                return $$eval$3(__x, context);
              }));
}

function getList(v, key, context) {
  return Core__Option.flatMap(get$4(v, key), (function (__x) {
                return $$eval$4(__x, context);
              }));
}

function getNode(v, key, context) {
  return Core__Option.flatMap(get$5(v, key), (function (__x) {
                return $$eval$5(__x, context);
              }));
}

var SettingsJSON;

var Context;

var Value = {
  getDynamicPathFromSettings: getDynamicPathFromSettings,
  $$String: $$String,
  Float: Float,
  Bool: Bool,
  $$Object: $$Object,
  List: List,
  $$Node: $$Node,
  deserialize: deserialize
};

export {
  SettingsJSON ,
  Context ,
  bindingKey ,
  Value ,
  deserialize$1 as deserialize,
  getString ,
  getFloat ,
  getBool ,
  getObject ,
  getList ,
  getNode ,
}
/* No side effect */
